export default __webpack_public_path__ + "2cbdb782b91279e8e8e251a945626166.png";